import React from 'react';
import Helmet from 'react-helmet';
import config from '../../config/SiteConfig';
import ProjectListing from '../components/ProjectListing/ProjectListing';
import Footer from '../components/Footer/Footer';
import Hero from '../components/Hero/hero';

const Index = props => {
  // const projectEdges = props.data.allMarkdownRemark.edges;
  return (
    <div className="container index-container">
      <Hero cover={config.siteHero} link="#content" />
      <Helmet>
        <title>{config.siteTitle}</title>
      </Helmet>
      <p id="content" style={{ textAlign: `justify`, fontWeight: `300`, height: `initial` }}>
        <span style={{ float: `left`, paddingRight: `4px`, lineHeight: `100%`, fontSize: `28px`, marginBottom: `0`, marginTop: `5px`, fontWeight: `700` }}>THE VISION</span> of our company is to
        create well-articulated architectural space through elegant and efficent forms to give our clients a feeling of
        exclusivity. Our design philosophy is based on emotional and an opulent feel of the space which is clearly
        expressed by the <strong>simplicity</strong> and <strong>purity</strong> of the shape.<br /><br />
        However we not only offer exclusive design solutions, we also incorporate in-house engineering and development of manufacturing techniques to help us realize such designs with as little compromise as possible.
      </p>
      <p style={{ textAlign: `center`, marginTop: `20px` }}>Contact us<br /><strong>office@digitalarchitects.at</strong></p>
      {/* <div style={{ display: `flex`, flexDirection: `row`, marginBottom: `50px` }}>
        <p style={{ width: `50%`, margin: `0 auto`, textAlign: `center` }}>
          <h3>Contact us</h3>
          RUDOLFSPLATZ 5<br />
          1010 VIENNA<br />
          AUSTRIA<br />
          <br />
          +43 660 6666 024<br />
          info@digtalarchitects.at<br />
          www.digitalarchitects.at<br />
        </p>
        <h1 style={{ width: `50%`, margin: `0 auto`, letterSpacing: `0.2rem` }}>DIGITAL ARCHITECTS</h1>
      </div> */}
      {/* <ProjectListing projectEdges={projectEdges} /> */}
      <Footer />
    </div>
  );
};

export default Index;

// /* eslint no-undef: "off" */
// export const pageQuery = graphql`
//   query IndexQuery {
//     allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC }) {
//       edges {
//         node {
//           fields {
//             slug
//           }
//           frontmatter {
//             service
//             client
//             cover {
//               childImageSharp {
//                 sizes(maxWidth: 850, quality: 90, traceSVG: { color: "#f3f3f3" }) {
//                   ...GatsbyImageSharpSizes_tracedSVG
//                 }
//               }
//             }
//           }
//         }
//       }
//     }
//   }
// `;



// WEBPACK FOOTER //
// ./src/pages/index.jsx